import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ContactSupportPage from '@/pages/contact-support/page';
import DisputeResolutionPage from '@/pages/dispute-resolution/page';
import SmQ1Page from '@/pages/cancelling-my-subscription/page';
import SmQ2Page from '@/pages/does-my-subscription-automatically-renew/page';
import SmQ3Page from '@/pages/what-if-I-never-received-the-product-or-service/page';
import BpQ1Page from '@/pages/where-is-my-refund/page';
import BpQ2Page from '@/pages/I-dont-recognize-this-charge/page';
import BpQ3Page from '@/pages/I-was-unaware-of-the-charges/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/contact-support', element: <ContactSupportPage /> },
  { path: '/dispute-resolution', element: <DisputeResolutionPage /> },
  { path: '/cancelling-my-subscription', element: <SmQ1Page /> },
  { path: '/does-my-subscription-automatically-renew', element: <SmQ2Page /> },
  { path: '/what-if-I-never-received-the-product-or-service', element: <SmQ3Page /> },
  { path: '/where-is-my-refund', element: <BpQ1Page /> },
  { path: '/I-dont-recognize-this-charge', element: <BpQ2Page /> },
  { path: '/I-was-unaware-of-the-charges', element: <BpQ3Page /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
